<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetOrganizationName" });
import { InputEntity, InputOrganizationName } from "../../index.js";
import { SelectCountry } from "../../../address/index.js";
import { normalizeText, getEntitiesByCountryCode } from "./regex.js";
export let name;
export let entity;
export let countryCode;
const DOMAIN = import.meta.env.VITE_DOMAIN;
const HAS_COUNTRY = countryCode !== void 0;
const extractEntityFromString = (input, countryCode2) => {
    if (countryCode2 === void 0) {
        return void 0;
    }
    if (input === void 0) {
        return void 0;
    }
    if (input === "") {
        return void 0;
    }
    const NORMALIZED_NAME = normalizeText(input);
    const LOCALIZED_ENTITIES = getEntitiesByCountryCode(countryCode2);
    return LOCALIZED_ENTITIES.find(({ regex }) => NORMALIZED_NAME.match(regex));
};
const updateEntity = (name2, countryCode2) => {
    const ENTITY = extractEntityFromString(name2, countryCode2);
    if (ENTITY === void 0) {
        return;
    }
    entity = ENTITY.name;
};
const updateOrganizationName = (entity2, countryCode2) => {
    const ENTITY = extractEntityFromString(entity2, countryCode2);
    if (ENTITY === void 0) {
        return;
    }
    name = normalizeText(name).replace(ENTITY.regex, "");
};
$: updateEntity(name, countryCode);
$: updateOrganizationName(entity, countryCode);
</script>


{#if DOMAIN === 'internal' || !HAS_COUNTRY}
    <SelectCountry bind:key = { countryCode } />
{/if}

<div class = 's8-organization-basic'>

    <div class = 's8-name'>
        <InputOrganizationName
            bind:value = { name }
            on:blur
            isReadonly = { DOMAIN !== 'internal' }
        />
    </div>

    <div class = 's8-entity'>
        <InputEntity bind:value = { entity } { countryCode } />
    </div>
</div>

<style>
    div.s8-organization-basic {
        display: flex;
        -moz-column-gap: 10px;
             column-gap: 10px;
    }

        div.s8-organization-basic div.s8-name {
            flex: 1;
        }

        div.s8-organization-basic div.s8-entity {
            max-width: 200px;
        }</style>